import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsSalesItem({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M4.5 15.5a1 1 0 100-2 1 1 0 000 2zm7.15 0a1 1 0 100-2 1 1 0 000 2zm1.98-10.83c.27 0 .47.04.62.1a.7.7 0 01.31.27c.06.1.09.22.09.33 0 .1-.02.21-.05.31-.03.09-1 3.89-1.08 4.13a1.7 1.7 0 01-.46.8c-.19.14-.42.21-.7.21H4.28l.2.99h7.81c.46 0 .68.2.68.58 0 .18-.04.35-.13.5-.1.13-.27.2-.53.2H4.2a.84.84 0 01-.47-.13 1 1 0 01-.32-.33 4.11 4.11 0 01-.33-.9l-1.27-7.8H.75a.99.99 0 01-.47-.15.65.65 0 01-.24-.54c0-.24.02-.35.15-.48.13-.12.3-.18.52-.18h1.43a1 1 0 01.46.08c.2.1.35.27.4.49l.08.24.06.32.05.42.09.54h10.35zm-6.9-.46L8.6 2.33c.22-.21.46-.32.72-.33.26 0 .5.1.71.32l1.89 1.9h-5.2z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgSettingsSalesItem.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsSalesItem.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgSettingsSalesItem svgRef={ref} {...props} />
));
export default ForwardRef;
